import PetHeader from './components/pet/PetHeader';
import PetFeatureItems from './components/pet/PetFeatureItems';
import PetCourseItems from './components/pet/PetCourseItems';
import PetTrainingFeatureItems from './components/pet/PetTrainingFeatureItems';
import PetLinkItems from './components/pet/PetLinkItems';
import PetAreaMap from './components/pet/PetAreaMap';

if (document.querySelector('[data-role="pet-page"]')) {
  new PetHeader();
  new PetFeatureItems();
  new PetCourseItems();
  new PetTrainingFeatureItems();
  new PetLinkItems();
  new PetAreaMap();
}
